import { render } from "./clueContainer.vue?vue&type=template&id=30713e13&bindings={\"clues\":\"props\",\"direction\":\"props\",\"clueFocus\":\"props\",\"settingsObject\":\"props\",\"primaryClueFocusEar\":\"options\",\"clueClickToAppEar\":\"options\"}"
import script from "./clueContainer.vue?vue&type=script&lang=js"
export * from "./clueContainer.vue?vue&type=script&lang=js"
script.render = render

export default script